import React, { useState, useEffect } from "react";
import { Typography } from "@material-tailwind/react";
import ConciliationHearingReport from "./ConciliationHearingReport";
import InstructionHearingReport from "./InstructionHearingReport";
import LawyerFeedbackForm from "./LawyerFeedbackForm";
import { isCombinedHearingReportValid } from "../utils/hearingReportValidation";

interface CombinedHearingReportProps {
  onChange: (reportData: any) => void;
  includeLawyerFeedback?: boolean;
}

const CombinedHearingReport: React.FC<CombinedHearingReportProps> = ({
  onChange,
  includeLawyerFeedback = true,
}) => {
  const [conciliationData, setConciliationData] = useState<any>(null);
  const [instructionData, setInstructionData] = useState<any>(null);
  const [lawyerFeedbackData, setLawyerFeedbackData] = useState<any>(null);
  const [isValid, setIsValid] = useState(false);

  // Validate combined form when either part changes
  useEffect(() => {
    // Both reports must be valid
    const isCombinedValid = isCombinedHearingReportValid(
      !!conciliationData?.isValid,
      !!instructionData?.isValid,
      !!lawyerFeedbackData?.isValid,
      includeLawyerFeedback,
    );

    setIsValid(isCombinedValid);

    // If we have both sets of data, combine them and send to parent
    if (conciliationData && instructionData && (includeLawyerFeedback ? lawyerFeedbackData : true)) {
      // Merge both formatted data objects
      const combinedFormattedData = {
        ...conciliationData.formattedData,
        ...instructionData.formattedData,
        ...(includeLawyerFeedback ? lawyerFeedbackData?.formattedData || {} : {}),
      };

      onChange({
        conciliationData,
        instructionData,
        lawyerFeedbackData,
        isValid: isCombinedValid,
        formattedData: combinedFormattedData,
      });
    }
  }, [conciliationData, instructionData, lawyerFeedbackData, includeLawyerFeedback, onChange]);

  const handleConciliationDataChange = (data: any) => {
    setConciliationData(data);
  };

  const handleInstructionDataChange = (data: any) => {
    setInstructionData(data);
  };

  const handleLawyerFeedbackChange = (data: any) => {
    setLawyerFeedbackData(data);
  };

  return (
    <div className="space-y-8">
      <div className="border-b pb-6">
        <ConciliationHearingReport
          onChange={handleConciliationDataChange}
          includeLawyerFeedback={false}
        />
      </div>

      <div className="border-b pb-6">
        <InstructionHearingReport
          onChange={handleInstructionDataChange}
          includeLawyerFeedback={false}
        />
      </div>

      {includeLawyerFeedback && (
        <div>
          <LawyerFeedbackForm onChange={handleLawyerFeedbackChange} />
        </div>
      )}
    </div>
  );
};

export default CombinedHearingReport;
